import React from "react";
import { Card, CardHeader, CardContent, Button, Grid, Typography } from "@material-ui/core";
import { SubscriptionPlan } from "api/company";
import { formatter } from "../../../../utils/helpers";
import i18n from "../i18n";
import "../clubStyle.scss";

type AvailableSubscriptionListProps = {
    plans: SubscriptionPlan[];
    stripePriceId?: string;
    selectPlan: (plan: SubscriptionPlan) => void;
    back: (showhide: boolean) => void;
};

// eslint-disable-next-line arrow-body-style
const AvailableSubscriptionList = ({ plans, stripePriceId, selectPlan, back }: AvailableSubscriptionListProps) => {
    return plans && (
        <Card variant="outlined" className="subscriptionCard">
            <Grid item xs={12}>
                {plans.map((p) => (
                    <Card variant="outlined" style={{ width: "100%" }} key={p.stripePriceId}>
                        <CardHeader title={p.title} />
                        <CardContent>
                            <Grid container spacing={1}>

                                <Grid item xs={4}>
                                    <Typography>{i18n.subscriptionType}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    {i18n.subscriptionTypes[p.subscriptionType].replace("_", " ")}
                                </Grid>

                                <Grid item xs={4}>
                                    <div style={{ display: "flex", direction: "rtl" }}>
                                        {stripePriceId && (p.stripePriceId === stripePriceId) && (
                                            <Button size="small" onClick={() => selectPlan(p)} variant="contained" color="default">{i18n.managePlan}</Button>
                                        )}
                                        {!(stripePriceId && (p.stripePriceId === stripePriceId)) && (
                                            <Button size="small" onClick={() => selectPlan(p)} variant="contained" color="primary">{i18n.selectPlan}</Button>
                                        )}
                                    </div>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography>{i18n.pricePerSeat}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    {formatter.format(p.priceCentsPerSeat / 100)}
                                </Grid>

                                <Grid item xs={12}>
                                    {p.description}
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                ))}
            </Grid>
            {stripePriceId && (
                <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
                    <Button
                        color="primary"
                        style={{ margin: "16px" }}
                        onClick={() => back(false)}
                    >
                        {i18n.cancel}
                    </Button>
                </Grid>
            )}
        </Card>
    );
};

export default AvailableSubscriptionList;
